function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#da2031"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,7.5h10v15h-10V7.5Z",
    style: {
      fill: "#0066b2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12.625,
    r: 1.375,
    style: {
      fill: "#ffd300"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 1.5,
    style: {
      fill: "#da2031"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12.25,
    r: 1,
    style: {
      fill: "#ffd300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.105,9c-.124.056-.171.158-.181.259-.006.085.031.181.035.265,0,.143-.148.191-.148.396,0,.07.065.148.065.331-.011.096-.065.117-.125.125-.069,0-.125-.056-.125-.125,0-.032.012-.063.035-.086.004-.004.008-.009.013-.013.029-.029.068-.04.067-.116,0-.039-.025-.075-.049-.144-.023-.067-.006-.179.048-.245-.088.034-.141.118-.169.193-.029.092-.004.146-.043.223-.024.05-.053.07-.081.112-.032.045-.07.151-.07.2,0,.345.28.625.625.625s.625-.28.625-.625c0-.049-.037-.155-.07-.2-.027-.042-.057-.062-.081-.112-.039-.077-.014-.13-.043-.223-.028-.075-.081-.159-.169-.193.054.066.071.178.048.245-.024.069-.05.104-.05.144,0,.076.039.087.067.116.005.004.009.008.013.013.022.023.035.054.035.086,0,.069-.056.125-.125.125-.069-.009-.119-.041-.125-.125,0-.241.103-.256.103-.434,0-.254-.228-.375-.228-.561,0-.064.014-.171.103-.256h0ZM2.25,14.25h1.25v6h-1.25v-6ZM6.5,14.25h1.25v6h-1.25v-6ZM3.75,14.25h2.5l-1.25.75-1.25-.75ZM3.75,15.25h2.5v.5h-2.5v-.5ZM3.75,18.75h2.5v.5h-2.5v-.5ZM3.75,19.5h2.5l-1.25.75-1.25-.75Z",
    style: {
      fill: "#ffd300"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 17.25,
    r: 1.25,
    style: {
      fill: "#ffd300"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 16.588,
    r: 0.25,
    style: {
      fill: "#da2032"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 17.912,
    r: 0.25,
    style: {
      fill: "#da2032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,15.85c.407,0,.738.33.738.738s-.33.737-.738.737c-.324,0-.588.263-.588.587s.264.588.588.588v.15c-.407,0-.738-.33-.738-.738s.33-.737.738-.737c.324,0,.588-.263.588-.587s-.264-.588-.588-.588v-.15Z",
    style: {
      fill: "#da2032"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/MN.76909002cfd064e20fe4724728d33271.svg";
export { ForwardRef as ReactComponent };